import { EmployeesState, TypesEnum, EmployeeDashboardActionTypes } from './types';

const initialState: EmployeesState = {
    data: [],
    error: '',
    loading: false,
    Page: 1,
};

// Reducer
export function employeesReducer(state = initialState, action: EmployeeDashboardActionTypes): EmployeesState {
    switch (action.type) {
        case TypesEnum.employeesRequested: {
            return { ...state, loading: true, error: '', Page: 1 };
        }
        case TypesEnum.moreEmployeesRequested: {
            return { ...state, loading: true, error: '', Page: state.Page + 1 };
        }
        case TypesEnum.employeesRequestFailed: {
            return { ...state, loading: false, error: action.payload };
        }
        case TypesEnum.employeesReceived: {
            if (state.Page === 1) {
                return { ...state, loading: false, data: action.payload };
            } else {
                return { ...state, loading: false, data: [...state.data, ...action.payload] };
            }
        }
        default: {
            return state;
        }
    }
}
